<template>
  <v-container v-if="RBAC_system_VIEW_PERFORMANCE">
    <v-row justify="center">
      <v-col cols="6">
        <my-datepicker
          @input="loadData"
          v-model="dateInz"
          :label="$t('date_inz')"
          required="true"
        />
      </v-col>
      <v-col cols="6">
        <my-datepicker
          @input="loadData"
          v-model="dateEnd"
          :label="$t('date_end')"
          required="true"
        />
      </v-col>
      <v-col cols="12">
        <v-card class="mx-auto text-center">
          <v-card-text>
            <GChart
              :resizeDebounce="1000"
              type="LineChart"
              :data="totRequestData"
              :options="totRequestOptions"
            />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <div class="display-1">{{ $t("num_request") }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card class="mx-auto text-center">
          <v-card-text>
            <GChart
              :resizeDebounce="1000"
              type="ColumnChart"
              :data="responseTimeData"
              :options="responseTimeOptions"
            />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <div class="display-1">{{ $t("response_time") }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import { GChart } from "vue-google-charts";

import Swal from "sweetalert2";
let _ = this;
export default {
  name: "performance",
  components: { MyDatepicker, GChart },
  data() {
    return {
      dateInz: null,
      dateEnd: null,
      RBAC_system_VIEW_PERFORMANCE: false,

      totRequestData: [],
      totRequestOptions: {
        curveType: "function",
        legend: { position: "bottom" },
        height: 500,
        lineWidth: 5,
        series: {
          0: { color: this.$vuetify.theme.themes.light.success },
          1: { color: this.$vuetify.theme.themes.light.warning },
          2: { color: this.$vuetify.theme.themes.light.error },
        },
      },
      responseTimeData: [],
      responseTimeOptions: {
        curveType: "function",
        legend: { position: "bottom" },
        height: 500,
        lineWidth: 5,
        series: {
          0: { color: this.$vuetify.theme.themes.light.primary },
        },
      },
    };
  },

  methods: {
    loadData() {
      let _ = this;
      _.totRequestData = [];
      _.responseTimeData = [];
      this.chiamataAxios("POST", "/auth/portal/getPerformance", {
        body: {
          filter: {
            dateInz: _.dateInz,
            dateEnd: _.dateEnd,
          },
        },
      }).then((response) => {
        // Carica dati
        _.responseTimeData = [[_.$t("period"), _.$t("duration_sec")]];
        response.data.responseTime.forEach((andamento) => {
          _.responseTimeData.push([andamento.key, andamento.value]);
        });
        _.totRequestData = [
          [
            _.$t("period"),
            _.$t("success"),
            _.$t("app_error"),
            _.$t("auth_error"),
          ],
        ];
        response.data.totRequest.forEach((andamento) => {
          _.totRequestData.push([
            andamento.key,
            andamento.value0,
            andamento.value1,
            andamento.value2,
          ]);
        });
      });
    },
  },
  created() {
    this.dateEnd = new Date().toISOString().slice(0, 10);
    let dateInz = new Date();
    dateInz.setDate(dateInz.getDate() - 7);
    this.dateInz = dateInz.toISOString().slice(0, 10);
    this.loadData();
    this.RBAC_system_VIEW_PERFORMANCE = this.checkUserRole(
      "system",
      "VIEW_PERFORMANCE"
    );
  },
};
</script>

